/**
 * Конвертация между строковым контрактом компонентов ввода даты/времени
 * и объектом Date, который нужен react-datepicker.
 *
 * Строки совпадают с форматом нативных <input type="date|time|datetime-local">,
 * поэтому вызывающий код (фильтры, параметры API, смены камер) не меняется.
 */

export const MODES = { TIME: 'time', DATE: 'date', DATETIME: 'datetime' };

const pad = (value) => String(value).padStart(2, '0');

const TIME_RE = /^(\d{2}):(\d{2})(?::(\d{2}))?$/;
const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATETIME_RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/;

// Опорная дата для режима «только время»: день значения не имеет,
// но Date без него не построить.
const TIME_ANCHOR = [2000, 0, 1];

const isValidParts = (year, month, day, hours, minutes, seconds) => {
  if (hours > 23 || minutes > 59 || seconds > 59) return false;
  const date = new Date(year, month - 1, day, hours, minutes, seconds);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const parseValue = (mode, value, withSeconds = false) => {
  if (typeof value !== 'string' || value === '') return null;

  if (mode === MODES.TIME) {
    const match = TIME_RE.exec(value);
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    const seconds = withSeconds ? Number(match[3] || 0) : 0;
    if (hours > 23 || minutes > 59 || seconds > 59) return null;
    return new Date(TIME_ANCHOR[0], TIME_ANCHOR[1], TIME_ANCHOR[2], hours, minutes, seconds);
  }

  if (mode === MODES.DATE) {
    const match = DATE_RE.exec(value);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (!isValidParts(year, month, day, 0, 0, 0)) return null;
    return new Date(year, month - 1, day);
  }

  const match = DATETIME_RE.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const hours = Number(match[4]);
  const minutes = Number(match[5]);
  const seconds = withSeconds ? Number(match[6] || 0) : 0;
  if (!isValidParts(year, month, day, hours, minutes, seconds)) return null;
  return new Date(year, month - 1, day, hours, minutes, seconds);
};

export const formatValue = (mode, date, withSeconds = false) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';

  const time =
    `${pad(date.getHours())}:${pad(date.getMinutes())}` +
    (withSeconds ? `:${pad(date.getSeconds())}` : '');
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

  if (mode === MODES.TIME) return time;
  if (mode === MODES.DATE) return day;
  return `${day}T${time}`;
};

export const displayFormat = (mode, withSeconds = false) => {
  const time = withSeconds ? 'HH:mm:ss' : 'HH:mm';
  if (mode === MODES.TIME) return time;
  if (mode === MODES.DATE) return 'dd.MM.yyyy';
  return `dd.MM.yyyy ${time}`;
};
